{
  "CANNED_MGMT": {
    "HEADER": "Atsakymų Ruošiniai",
    "LEARN_MORE": "Learn more about canned responses",
    "DESCRIPTION": "Canned Responses are pre-written reply templates that help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a canned response during a conversation. ",
    "HEADER_BTN_TXT": "Pridėti atsakymo ruošinį",
    "LOADING": "Atsakymų ruošinių gavimas...",
    "SEARCH_404": "Šią užklausą atitinkančių elementų nėra.",
    "LIST": {
      "404": "Šioje paskyroje nėra galimų atsakymų ruošinių.",
      "TITLE": "Tvarkyti atsakymų ruošinius",
      "DESC": "Atsakymų ruošiniai yra iš anksto nustatyti atsakymų šablonai, kuriuos galima naudoti norint greitai išsiųsti atsakymus į pokalbius.",
      "TABLE_HEADER": {
        "SHORT_CODE": "Trumpasis kodas",
        "CONTENT": "Turinys",
        "INBOXES": "Gautų laiškų aplankai",
        "ACTIONS": "Veiksmai"
      },
      "ALL_INBOXES": "Visi gautų laiškų aplankai",
      "FILTER": {
        "ALL_INBOXES": "Visi gautų laiškų aplankai",
        "NO_INBOX": "Be gautų laiškų aplanko",
        "SEARCH_PLACEHOLDER": "Ieškoti gautų laiškų aplankų"
      }
    },
    "ADD": {
      "TITLE": "Pridėti atsakymo ruošinį",
      "DESC": "Atsakymų ruošiniai yra iš anksto nustatyti atsakymų šablonai, kuriuos galima naudoti norint greitai išsiųsti atsakymus į pokalbius.",
      "CANCEL_BUTTON_TEXT": "Atšaukti",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Trumpasis kodas",
          "PLACEHOLDER": "Prašome įvesti trumpą kodą.",
          "ERROR": "Trumpasis Kodas yra būtinas."
        },
        "SUBJECT": {
          "LABEL": "Tema (tik el. paštas)",
          "PLACEHOLDER": "Pasirinktinė tema el. pašto atsakymams / naujiems pokalbiams"
        },
        "CONTENT": {
          "LABEL": "Žinutė",
          "PLACEHOLDER": "Parašykite žinutę, kurią norėsite išsaugoti kaip šabloną vėlesniam naudojimui.",
          "ERROR": "Yra reikalingas pranešimas."
        },
        "ATTACHMENTS": {
          "LABEL": "Priedai"
        },
        "INBOXES": {
          "LABEL": "Gautų laiškų aplankai",
          "PLACEHOLDER": "Pasirinkite gautų laiškų aplankus (nebūtina, palikite tuščią visiems aplankams)"
        },
        "SUBMIT": "Pateikti"
      },
      "API": {
        "SUCCESS_MESSAGE": "Atsakymų ruošinys pridėtas sėkmingai.",
        "ERROR_MESSAGE": "Nepavyko prisijungti prie Woot serverio. Bandykite dar kartą vėliau."
      }
    },
    "EDIT": {
      "TITLE": "Taisyti atsakymo ruošinį",
      "CANCEL_BUTTON_TEXT": "Atšaukti",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Trumpasis kodas",
          "PLACEHOLDER": "Prašome įvesti trumpą kodą.",
          "ERROR": "Trumpasis Kodas yra būtinas."
        },
        "SUBJECT": {
          "LABEL": "Tema (tik el. paštas)",
          "PLACEHOLDER": "Pasirinktinė tema el. pašto atsakymams / naujiems pokalbiams"
        },
        "CONTENT": {
          "LABEL": "Žinutė",
          "PLACEHOLDER": "Parašykite žinutę, kurią norėsite išsaugoti kaip šabloną vėlesniam naudojimui.",
          "ERROR": "Yra reikalingas pranešimas."
        },
        "ATTACHMENTS": {
          "LABEL": "Priedai"
        },
        "INBOXES": {
          "LABEL": "Gautų laiškų aplankai",
          "PLACEHOLDER": "Pasirinkite gautų laiškų aplankus (nebūtina, palikite tuščią visiems aplankams)"
        },
        "SUBMIT": "Pateikti"
      },
      "BUTTON_TEXT": "Taisyti",
      "API": {
        "SUCCESS_MESSAGE": "Atsakymų Ruošinys atnaujintas sėkmingai.",
        "ERROR_MESSAGE": "Nepavyko prisijungti prie Woot serverio. Bandykite dar kartą vėliau."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Ištrinti",
      "API": {
        "SUCCESS_MESSAGE": "Atsakymų ruošinys ištrintas sėkmingai.",
        "ERROR_MESSAGE": "Nepavyko prisijungti prie Woot serverio. Bandykite dar kartą vėliau."
      },
      "CONFIRM": {
        "TITLE": "Patvirtinti Ištrynimą",
        "MESSAGE": "Ar tikrai norite ištrinti ",
        "YES": "Taip, Trinti ",
        "NO": "Ne, Išsaugoti "
      }
    }
  }
}
